import { CatalogueListingPreview } from "@/components/cms-puck/previews/CatalogueListingPreview";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";

/**
 * Aperçu canvas du bloc « Résultats de recherche ».
 * Sur le site, les résultats proviennent des paramètres d'URL `/search?…`.
 */
export function CatalogueSearchResultsPreview({
  target = "ARTWORKS",
  columns = 4,
  showRegistrationNumber = false,
  showFilters = true,
}: {
  target?: "ARTWORKS" | "MULTIPRINTS";
  columns?: number;
  showRegistrationNumber?: boolean;
  showFilters?: boolean;
}) {
  const vt = useVisibleT();
  return (
    <div className="w-full">
      <p className="mb-3 text-xs cms-page-text-muted">
        {vt(
          "cms.new.preview.searchResults.hint",
          "Aperçu indicatif — sur le site, les résultats sont chargés depuis l'URL",
        )}{" "}
        <code className="text-[10px]">/search?query=…</code>.
      </p>
      <CatalogueListingPreview
        target={target}
        columns={columns}
        showRegistrationNumber={showRegistrationNumber}
        showFilters={showFilters}
      />
    </div>
  );
}
